import React from "react"
import Link from "./link"
import CallToAction from "./call-to-action"
import { graphql } from "gatsby"
import { Parallax } from "react-parallax"

import { FullWidthTeaserFieldsFragment } from "../../graphql-types"

export const query = graphql`
  fragment FullWidthTeaserFields on DatoCmsFullwidthTeaser {
    title
    componentId: key
    blurbNode {
      childMarkdownRemark {
        html
      }
    }
    image {
      url(imgixParams: { w: "1800", fm: "jpg" })
    }
    video {
      video {
        high: mp4Url(res: high)
        medium: mp4Url(res: medium)
        low: mp4Url(res: low)
        streamingUrl
      }
    }
    url
    urltext
    ctaType
  }
`

export interface FullwidthTeaserProps extends FullWidthTeaserFieldsFragment {
  variant?: "extra-margin"
  parallaxDisabled?: boolean
}

const FullwidthTeaser: React.FC<FullwidthTeaserProps> = props => {
  const title = props.title || ""
  const blurb =
    (props.blurbNode &&
      props.blurbNode &&
      props.blurbNode.childMarkdownRemark &&
      props.blurbNode.childMarkdownRemark.html) ||
    ""
  const url = props.url || ""
  const urltext = props.urltext || ""
  const imgSrc = props.image && props.image.url
  const video = props.video && props.video.video
  const ctatype = props.ctaType || "text"
  const parallaxDisabled = props.parallaxDisabled || false

  return (
    <React.Fragment>
      <section
        id={props.componentId}
        className={`c-fullwidth-teaser o-row ${
          props.variant ? `-${props.variant}` : ""
        }`}
        data-aos="fullwidth-teaser"
      >
        {!video && imgSrc && (
          <Parallax
            className={`c-fullwidth-teaser__parallax ${
              parallaxDisabled ? `-disabled` : ""
            }`}
            bgImage={imgSrc}
            strength={300}
            disabled={parallaxDisabled}
          ></Parallax>
        )}
        {video && (
          <video
            loop={true}
            autoPlay={true}
            muted
            playsInline={true}
            className="c-fullwidth-teaser__video"
          >
            <source src={video.high} type="video/mp4" />
          </video>
        )}

        <div className="o-wrapper c-fullwidth-teaser__container">
          <div className="c-fullwidth-teaser__container-content">
            <h2 className="c-heading--b c-fullwidth-teaser__title">{title}</h2>
            <div
              className="c-fullwidth-teaser__container-content-blurb"
              dangerouslySetInnerHTML={{ __html: blurb }}
            />
            {url && urltext && ctatype === "button" && (
              <CallToAction url={url} color={"green"}>
                {urltext}
              </CallToAction>
            )}

            {url && urltext && ctatype === "text" && (
              <Link url={url}>{urltext}</Link>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}
export default FullwidthTeaser
